import LegalLayout from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" effectiveDate="October 8, 2026">
      <p><strong>Provider:</strong> SALESARENA HQ LLC.<br />
      <strong>Contact:</strong> <a href="mailto:support@salesarenahq.com">support@salesarenahq.com</a></p>

      <p>We want you to be genuinely happy with SalesArena HQ. This policy explains when refunds are available and how to request one.</p>

      <p><em>This policy is drafted in plain language and has not been reviewed by an attorney.</em></p>

      <h2>1. Free Trial</h2>
      <p>Every new Company gets a <strong>30-day free trial with full Premium access</strong>. A valid payment method is required to start the trial, but you are <strong>not charged during the trial period</strong>. Unless you cancel before the trial ends, the subscription automatically converts to a paid plan and your card is charged the then-current rate. You can cancel anytime during the trial to avoid any charge.</p>

      <h2>2. 7-Day Money-Back Guarantee</h2>
      <p>If you subscribe to a paid plan and decide it's not for you, request a refund within <strong>7 days of your first paid charge</strong> and we will refund 100% of that charge — no questions asked. This applies to the first paid month only.</p>

      <h2>3. Pro-rata Refunds</h2>
      <p>After the 7-day window, subscriptions are non-refundable except in the following cases:</p>
      <ul>
        <li><strong>Extended outage:</strong> if the Service is unavailable for more than 24 consecutive hours due to our infrastructure, we will issue a pro-rata credit or refund upon request.</li>
        <li><strong>Duplicate charge:</strong> if you were double-billed for the same billing cycle, we refund the duplicate charge automatically once verified.</li>
        <li><strong>Feature removal:</strong> if we remove a material feature that your subscription depended on and provide fewer than 30 days' notice, you may request a pro-rata refund for the remaining unused period.</li>
      </ul>

      <h2>4. Annual Plans</h2>
      <p>Annual plans follow the 7-day money-back guarantee. After 7 days, remaining months are non-refundable but you may cancel to prevent renewal.</p>

      <h2>5. Cancellation vs. Refund</h2>
      <p>You can cancel your subscription yourself at any time — no email required. Go to <em>Dashboard → Billing</em> and click <strong>&ldquo;Manage billing &amp; cancel&rdquo;</strong> to open the secure Stripe customer portal, where you can cancel in a few clicks. <strong>If you cancel before your 30-day free trial ends, you will not be charged.</strong> Cancelling a paid subscription stops future renewals and you retain full access through the end of the current billing period; it does <strong>not</strong> automatically refund the current period. Refund requests (for charges already made) must be submitted separately per the policy above.</p>

      <h2>6. Non-Refundable Situations</h2>
      <ul>
        <li>Partial-month usage after the 7-day window (unless a case in §3 applies)</li>
        <li>Charges you dispute more than 60 days after they were incurred</li>
        <li>Fees for third-party services (Stripe processing, SARA Plus API costs) — refund requests for those must go directly to the third party</li>
      </ul>

      <h2>7. How to Request a Refund</h2>
      <p>Email <a href="mailto:support@salesarenahq.com">support@salesarenahq.com</a> from the Company Owner's account with:</p>
      <ul>
        <li>Your Company name</li>
        <li>Date of the charge</li>
        <li>Reason for the request</li>
      </ul>
      <p>We aim to respond within <strong>2 business days</strong>. Approved refunds are issued to the original payment method within 5–10 business days.</p>

      <h2>8. Chargebacks</h2>
      <p>Please contact us before initiating a bank or card chargeback — we can almost always resolve billing issues faster than a chargeback process. Unsupported chargebacks may result in account suspension.</p>

      <h2>9. Contact</h2>
      <p><a href="mailto:support@salesarenahq.com">support@salesarenahq.com</a></p>
    </LegalLayout>
  );
}
